
const symbol_by_code = (currency_code) => {
    switch (currency_code) {
        case 'USD':
        return '$';
        case 'EUR':
        return '€';
        case 'GBP':
        return '£';
        case 'JPY':
        return '¥';
        case 'CNY':
        return '¥';
        case 'PLN':
        return 'zł';
        case 'CZK':
        return 'Kč';
        default:
        return currency_code;
    }
}

export { symbol_by_code };